angular.module('admin.subscriptions').controller('ImportUsersCtrl',
    function ($uibModalInstance, subscription, Upload, config, SubscriptionCustomersImport) {

        this.duplicateActions = [{
            label: 'Associe a esta assinatura',
            value: 'asign'
        }, {
            label: 'Pule este usuário',
            value: 'skip'
        }, {
            label: 'Não faça nada. Aborte a importação',
            value: 'abort'
        }];

        this.request = {
            duplicateAction: 'asign',
            plan: subscription.plans[subscription.plans.length - 1].plan.id,
            number: subscription.number
        };


        this.subscription = subscription;

        this.step = 'file';


        this.selectFile = function (file) {
            this.file = file;
        }

        this.import = function () {
            this.step = 'progress';
            var req = {
                url: config.api + '/api/AdminSubscriptionUpload/Upload',
                method: 'POST',
                data: this.request,
                file: this.file
            };
            Upload.upload(req).then((res) => {

                this.response = res.data;
                this.step = 'progress2';

                this.totalUsers = res.data.items.length;
                this.processedUsers = 0;

                this.updateUsers();

            }, (err) => {});
        }

        this.updateUsers = function () {
            this.errors = [];

            var updateOne = () => {
                if (this.totalUsers <= this.processedUsers) {
                    this.step = 'finished';
                    return;
                }
                var user = this.response.items[this.processedUsers++];
                if (!user) {
                    this.step = 'finished';
                    return;
                }

                var sci = new SubscriptionCustomersImport({
                    number: this.subscription.number,
                    planId: this.request.plan,
                    email: user.email
                });

                sci.$save(() => {
                    updateOne();
                }, (err) => {
                    this.errors.push(err.data.message);
                    updateOne();
                });
            }

            updateOne();
        }

        this.startOver = function () {
            delete this.file;
            this.step = 'file';
        }

        this.copyTable = function () {
            var table = document.getElementById('tbResults');
            console.log(table);

            var selection = document.getSelection();
            selection.removeAllRanges();

            var range = document.createRange();
            range.selectNode(table);
            selection.addRange(range);

            document.execCommand('copy');

        }

        this.cancel = function () {
            if (this.response)
                $uibModalInstance.close();
            else
                $uibModalInstance.dismiss();
        }
    });